// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2b7adff4","977":"8a051f7c"}[chunkId] + ".chunk.js";
};